import './styles/TestCollage.scss'
import { useState } from 'react';
import Collage from '../components/Collage';

//mall images
import Collage1 from '../assets/images/collage/1.jpg';
import Collage2 from '../assets/images/collage/2.jpg';
import Collage3 from '../assets/images/collage/3.jpg';
import Collage4 from '../assets/images/collage/4.jpg';
import Collage5 from '../assets/images/collage/5.jpg';
import Collage6 from '../assets/images/collage/6.jpg';
import Collage7 from '../assets/images/collage/7.jpg';
import Collage8 from '../assets/images/collage/8.jpg';
import Collage9 from '../assets/images/collage/9.jpg';
import Collage10 from '../assets/images/collage/10.jpg';
import Collage11 from '../assets/images/collage/11.jpg';
import Collage12 from '../assets/images/collage/12.jpg';
import Collage13 from '../assets/images/collage/13.jpg';
import Collage14 from '../assets/images/collage/14.jpg';
import Collage15 from '../assets/images/collage/15.jpg';
import Collage16 from '../assets/images/collage/16.jpg';
import Collage17 from '../assets/images/collage/17.jpg';

interface Props {

}

const TestCollage: React.FC<Props> = ({}) =>{
    const [images, SetImages] = useState<string[]>([
        Collage1, Collage2, Collage3, Collage4, Collage5, Collage6, Collage7, Collage8, Collage9, Collage10, Collage11, Collage12, Collage13, Collage14, Collage15, Collage16, Collage17
    ]);

    return(
        <div className='TestCollage'>
            <div className='collage'>
                <Collage
                    mode='column'
                    spreadCount={2} minSpreadRatio={0.5} maxSpreadRatio={0.7}
                    frameWidth={.01} frameRadius={.02}
                    images={images}
                />
            </div>
        </div>
    );
}
export default TestCollage;